import { useEffect, useState } from "react";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import {languages, raceEthnicities} from "../../Common/MasterData";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import RegistrationDropdown from "../../CustomControls/RegistrationDropdown";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useDispatch } from "react-redux";
import { setPartiallyVerified, setFullyVerified } from "../../Redux/verificationReducer";
import ErrorModal from "../../Components/Security/ErrorModal";
import { toast } from "react-toastify";
import { updateEmail } from '../../Redux/emailReducer';
import { updateUserData } from '../../Redux/userReducer';

const RegistrationFormTwo = (isEditMode) => {
  const { t } = useTranslation();
  const dispatch= useDispatch();

  const isSSO = useSelector((state) => state.sso.isSSO); 
  const ssoDob = useSelector((state) => state.sso.ssoUserData);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const fromLogin = useSelector(state => state.fromLogin.fromLogin);
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState(null);
  const location = useLocation();
  const otherData = location.state?.otherData;
  const [formData, setFormData] = useState({
    phoneNumber: "",
    agreeToTexts: false,
    language: "",
    raceEthnicity: "",
  });
  const [form3Data, setForm3Data]=useState();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showEmailPhoneOptions, setShowEmailPhoneOptions] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState("");
  const [maskedPhone, setMaskedPhone] = useState("");
  const [enrollLink, setEnrollLink] = useState("");
  const [showModalR7, setShowModalR7] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [combinedFormDataForModal, setCombinedFormDataForModal] = useState({});

  const currentStep = location.state?.currentStep || (isHighmarkPortal ? 2 : 4);
  const totalSteps = location.state?.totalSteps || (isHighmarkPortal ? 2 : 4);
  const isNewRegistrationFlow = Boolean(
    location.state?.accessCode !== undefined ||
    location.state?.form3Data !== undefined ||
    location.state?.company !== undefined ||
    location.state?.healthPlanID !== undefined
  );

  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  const formData1 = location.state?.formData || location.state?.formData1 || {};
  const createAccountResponseData = location.state?.createAccountResponseData;

  useEffect(() => {
    if (location.state?.FormData1 ||location.state?.form2Data) {
      const incomingData = location.state.form2Data;
      setFormData(incomingData);
    }  
    if(location.state?.form3Data){
      setForm3Data(location.state.form3Data);
    }
    else {
      console.log("No combinedProviderData passed to form2.");
    }
  
  }, [location.state]);

  useEffect(() => {
    setCountry(formData1.country || (isHighmarkPortal ? "United States of America" : null));
  }, [formData1.country, isHighmarkPortal]);

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

     // If the field is phoneNumber, restrict input to numbers only
  if (id === "phoneNumber") {
    const numericValue = value.replace(/[^0-9]/g, ""); // Removes all non-numeric characters
    setFormData({
      ...formData,
      [id]: numericValue,
    });
  } else {
    const updatedFormData = {
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    };

    setFormData(updatedFormData);
  }
  };

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const isValidForm = () => {
    let formErrors = {};

    // Check for mandatory fields
    if (!formData.phoneNumber?.trim()) {
      formErrors.phoneNumber = "Phone Number is required.";
    }

    if (!formData.language?.trim()) {
      formErrors.language = "Language is required.";
    }

    // Only validate race/ethnicity if country is not Canada
    if (country && country !== "Canada" && !formData.raceEthnicity?.trim()) {
      formErrors.raceEthnicity = "Race / Ethnicity is required.";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };



  const handleEmailClick = () => {
    setShowModal(false);
    navigate('/forgotpassword', { state: { email: maskedEmail } });
  };

  const handlePhoneClick = async () => {
    try {
      const paramsObject = {
        EmailID: combinedFormDataForModal.EmailID,
        Phonenumber: combinedFormDataForModal.PhoneNo,
        FirstName: combinedFormDataForModal.FirstName,
        LastName: combinedFormDataForModal.LastName
      };
      await axios.post(
        Endpoints.TextForgotPassword,
        null,
        {
          params: { _Params: JSON.stringify(paramsObject) }
        }
      );
      setModalMessage("A temporary password has been sent to your registered phone number.");
      setShowEmailPhoneOptions(false);
      setShowModal(true);
    } catch (error) {
      setModalMessage("Failed to send temporary password. Please try again.");
      setShowEmailPhoneOptions(false);
      setShowModal(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isValidForm()) {
      const formattedDOB = new Date(formData1.dateOfBirth).toLocaleDateString("en-US");
      // Combine formData (Form 2 data) with formData1 (Form 1 data)
      const combinedFormData = {
        FirstName: formData1.firstName,
        LastName: formData1.lastName,
        PreferredName: formData1.preferredName,
        EmailID: formData1.email,
        PWD: formData1.password,
        ConfirmPassword: formData1.confirmPassword,
        AgreeTerms: formData1.agreeTerms,
        Country: country,
        Language: formData.language,
        Ethnicity: formData.raceEthnicity,
        PhoneNo: formData.phoneNumber,
        DOB: formattedDOB,
        TextNotificationStatus: formData.agreeToTexts ? "Yes" : "No",
        // Add any other necessary values as required for _Params
        Version: "1.0",
        AppLanguage: "English",
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal", // Modify this if it's dynamic
        // Add default or dynamic values as necessary
        Company:  location.state?.company || "",  // Ensure default if missing
        MemberID:  "",
        WhyHere:  "",
        WINBenefits: "Y",
        Promocode: location.state?.accessCode || (ssoData.Promocode? ssoData.Promocode : ""),
        Pronouns: "",
        UpdateFlag: "N",
        JourneyStatus: "",
        HealthPlanId: location.state?.healthPlanID || "",
        RelationshipStatus: "",
        IsHealthProfileCompleted: 0,
        BenefitProvider: form3Data || (ssoData.Promocode? "My employer": ""),
        SubscriberID: "",
        Gender: "",
        Contract: "",
        SecureCode: "",
        Goal: "",
        CountryCode: "",
      };

      if (isNewRegistrationFlow || (isSSO && isHighmarkPortal)) {
        setCombinedFormDataForModal(combinedFormData);
        setIsSubmitting(true);

        try {
          if (!createAccountResponseData || createAccountResponseData.Result !== 2) {
            setModalMessage("Unable to continue registration. Please restart the registration flow.");
            setShowModal(true);
            return;
          }

          dispatch(setPartiallyVerified());
          if (fromLogin) {
            const token=localStorage.getItem('AccessToken');
            if(token)
            {
              const expirationTime = Date.now() + 15 * 60 * 1000;
              localStorage.setItem('sessionExpiration', expirationTime.toString());
              localStorage.removeItem('sessionExpired');
              dispatch({ type: 'LOGIN_SUCCESS', payload: token });
              dispatch(setFullyVerified());
              dispatch(updateUserData(createAccountResponseData));
              dispatch(updateEmail(combinedFormData.EmailID));
              toast.success(t('profilesavedsucessfully'), { autoClose: 3000 });
              navigate('/home');
            }
          } else {
            if (!isHighmarkPortal) {
              if (combinedFormData.Country !== "United States of America") {
                const mergedFormData = {
                  ...combinedFormData,
                  BabyCountFlag: createAccountResponseData.BabyCountFlag
                };
                navigate("/patientconsent-form", {
                  state: {
                    updatedFormData: mergedFormData,
                    responseData: createAccountResponseData
                  }
                });
                return;
              }
            }

            const mergedFormData = {
              ...combinedFormData,
              BabyCountFlag: createAccountResponseData.BabyCountFlag
            };
            navigate("/healthprofilesetup", {state: {updatedFormData: mergedFormData}});
          }
        } finally {
          setIsSubmitting(false);
        }
      } else {
        // Pass the combinedFormData to the next component (accesscode)
        if(form3Data!=null && form3Data!= undefined){
          navigate("/benefit-options", { state: {combinedFormData,form3Data:form3Data, otherData:{...otherData}} });
        }
        else{
          navigate("/benefit-options", { state: {combinedFormData,ssoDob} });
        }
      }
    } else {
      console.log('Form has errors:', errors);
    }
  };

  const handleBack = () => {
    if (isNewRegistrationFlow) {
      navigate("/accesscode", {
        state: {
          formData: formData1,
          form2Data: formData,
          form3Data,
          accessCode: location.state?.accessCode || "",
          company: location.state?.company || "",
          healthPlanID: location.state?.healthPlanID || "",
          otherData: { ...otherData }
        }
      });
      return;
    }
    navigate("/registration-form-one", { state: { formData1: formData1 , form2Data: formData, form3Data, otherData: {...otherData} } });
  };

const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

  const handleModalCloseForResult7 = () => {
    setShowModalR7(false);
    navigate("/login");
  };
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#" onClick={(e) => e.preventDefault()}>
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      {/* Body Section */}
      
      <div className="registration-block-main">
            {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}
          
          {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-secondary-black">{t('nicetomeetyou')}</h3>
            <h3 className="page-heading-bold">{capitalizeFirstLetter(formData1?.preferredName) || capitalizeFirstLetter(formData1?.firstName)}</h3>
            <p>{t('setupyouraccout')}</p>
            <div className="registration-process-form-wrapper mt-5">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="phoneNumber"
                    className="form-label win-form-label mandatory"
                  >
                    {t('phonenumber')}
                    <span className="form-label win-form-label-d mandatory"></span>
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control-d  mobile-view"
                    id="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    maxLength="50"
                    autoComplete="off"
                  />
                  {errors.phoneNumber && <div className="form-field-error-message">{errors.phoneNumber}</div>}
                </div>
                <div className="mb-3 form-check win-form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input"
                    id="agreeToTexts"
                    checked={formData.agreeToTexts}
                    onChange={handleInputChange}
                  />
                  <label
                    className="form-check-label checkbox-radio-text"
                    htmlFor="agreeToTexts"
                  >
                    {isHighmarkPortal ? t('form2msghighmark') : t('form2msg')}
                  </label>
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="language"
                    className="form-label win-form-label mandatory"
                  >
                    {t('language')}
                  </label>
                  <RegistrationDropdown
                        id="language"
                        label={t("selectlanguage")}
                        options={languages.map((lang) => ({
                          id: lang.value,
                          name: lang.label,
                        }))}
                        selectedOption={
                          languages
                            .map((lang) => ({ id: lang.value, name: lang.label }))
                            .find((option) => option.name === formData.language) || null
                        }
                        onChange={handleInputChange}
                        searchable
                      />
                  {errors.language && <div className="form-field-error-message">{errors.language}</div>}
                </div>
                {country !== "Canada" && (
                <div className="mb-3">
                  <label
                    htmlFor="raceEthnicity"
                    className="form-label win-form-label mandatory"
                  >
                    {t('ethncity')}
                  </label>
                  <RegistrationDropdown
                    id="raceEthnicity"
                    label={t("raceethncity")}
                    options={raceEthnicities.map((race) => ({
                      id: race.value,
                      name: race.label,
                    }))}
                    selectedOption={
                      raceEthnicities
                        .map((race) => ({ id: race.value, name: race.label }))
                        .find((option) => option.name === formData.raceEthnicity) || null
                    }
                    onChange={handleInputChange}
                    searchable
                  />
                  {errors.raceEthnicity && <div className="form-field-error-message">{errors.raceEthnicity}</div>}
                </div>
                )}
                <div className="mb-3 mt-4">
                {isHighmarkPortal ? (
                      <>
                      <div className="pagination-wrapper mt-5">
                        <button className="previous-btn" onClick={handleBack} type="button"></button>                        
                        <span className="me-3">{currentStep} of {totalSteps}</span>                        
                        <button className="next-btn" onClick={handleSubmit} type="button"></button>
                      </div>
                      </>
                    ) : (
                      <>
                  <button className="win-btn-secondary  mobile-view me-3 mb-2 mb-md-0" onClick={handleBack} type="button">{t('back')}</button>
                  <button className="win-btn-primary  mobile-view" onClick={handleSubmit} type="button">
                  {t('nextbutton')}
                  </button>
                  </>
                    )}
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>

        <ErrorModal
          show={showModal}
          message={modalMessage}
          onClose={() => setShowModal(false)}
          enrollLink={enrollLink}
          showEmailPhoneOptions={showEmailPhoneOptions}
          maskedEmail={maskedEmail}
          maskedPhone={maskedPhone}
          onEmailClick={handleEmailClick}
          onPhoneClick={handlePhoneClick}
          closeButton={true}
        />
        <ErrorModal show={showModalR7} message={modalMessage} onClose={handleModalCloseForResult7} closeButton={true} />
        </div>
  );
};

export default RegistrationFormTwo;
